import React from 'react';

const smoothPath = (pts, tension = 0.2) => {
  let d = `M${pts[0][0].toFixed(1)},${pts[0][1].toFixed(1)}`;
  for (let i = 0; i < pts.length - 1; i++) {
    const p0 = pts[i - 1] || pts[i];
    const p1 = pts[i];
    const p2 = pts[i + 1];
    const p3 = pts[i + 2] || p2;
    const c1x = p1[0] + (p2[0] - p0[0]) * tension;
    const c1y = p1[1] + (p2[1] - p0[1]) * tension;
    const c2x = p2[0] - (p3[0] - p1[0]) * tension;
    const c2y = p2[1] - (p3[1] - p1[1]) * tension;
    d += ` C${c1x.toFixed(1)},${c1y.toFixed(1)} ${c2x.toFixed(1)},${c2y.toFixed(1)} ${p2[0].toFixed(1)},${p2[1].toFixed(1)}`;
  }
  return d;
};

/** Small numeric history chart; colors follow the current Bun theme. */
const Sparkline = ({
  data = [],
  height = 36,
  min,
  showDot = false,
  className = '',
}) => {
  const width = 120;
  const color = 'var(--bun-data-violet)';
  const pts = (data || []).filter((n) => typeof n === 'number' && !Number.isNaN(n));
  if (pts.length < 2) return null;

  const hasFloor = min != null;
  const lo = hasFloor ? Math.min(min, ...pts) : Math.min(...pts);
  const hi = Math.max(...pts);
  const span = hi - lo || 1;
  const padTop = 4; // keep the peak + end dot clear of the top edge
  const padBottom = hasFloor ? 0 : 4; // a pinned floor (e.g. 0) sits flush at the bottom
  const usableH = Math.max(1, height - padTop - padBottom);
  const stepX = width / (pts.length - 1);
  const coords = pts.map((v, i) => [i * stepX, padTop + usableH - ((v - lo) / span) * usableH]);

  const line = smoothPath(coords);
  const area = `${line} L${width},${height} L0,${height} Z`;
  const lastY = coords[coords.length - 1][1];

  return (
    <div className={`relative ${className}`}>
      <svg
        width="100%"
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        preserveAspectRatio="none"
        className="block"
        aria-hidden="true"
      >
        <path d={area} fill={color} fillOpacity="0.12" stroke="none" />
        <path
          d={line}
          fill="none"
          stroke={color}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          vectorEffect="non-scaling-stroke"
        />
      </svg>
      {showDot && (
        <span
          className="pointer-events-none absolute h-2 w-2 -translate-x-1/2 -translate-y-1/2 rounded-full ring-2 ring-bun-surface"
          style={{ left: '100%', top: `${(lastY / height) * 100}%`, backgroundColor: color }}
        />
      )}
    </div>
  );
};

export default Sparkline;
